import React from 'react';
import { motion } from 'framer-motion';
export function Dimensions() {
  const dimensions = [{
    num: '01',
    name: 'CREDIBILIDAD',
    points: '0-20 puntos',
    question: '¿Genera confianza en los primeros 3 segundos?',
    items: ['Calidad y consistencia del diseño', 'Presencia de HTTPS y certificados de seguridad', 'Consistencia entre redes sociales y web', 'Percepción general de profesionalismo']
  }, {
    num: '02',
    name: 'CLARIDAD',
    points: '0-20 puntos',
    question: '¿Es inmediatamente evidente qué hace la empresa?',
    items: ['Visibilidad de la propuesta de valor en pantalla inicial', 'Claridad del sector objetivo', 'Ausencia de ambigüedad en mensajes clave', 'Navegación intuitiva y estructurada']
  }, {
    num: '03',
    name: 'CONVERSIÓN',
    points: '0-20 puntos',
    question: '¿La presencia digital facilita que el visitante tome acción?',
    items: ['Visibilidad y claridad de los llamados a la acción', 'Fricción en formularios de contacto', 'Disponibilidad de información de contacto directa', 'Rutas claras hacia la conversión']
  }, {
    num: '04',
    name: 'AUTORIDAD',
    points: '0-20 puntos',
    question: '¿La empresa demuestra experiencia y trayectoria?',
    items: ['Presencia de casos de éxito o clientes representativos', 'Credenciales, certificaciones o premios visibles', 'Calidad del contenido sobre el sector', 'Testimonios verificables']
  }, {
    num: '05',
    name: 'RENDIMIENTO',
    points: '0-20 puntos',
    question: '¿La experiencia técnica está a la altura del negocio?',
    items: ['Velocidad de carga en dispositivos móviles y escritorio', 'Adaptabilidad real a pantallas pequeñas (Responsive)', 'Ausencia de errores técnicos visibles', 'Accesibilidad básica']
  }];
  return <section className="bg-arena-dark py-16 md:py-[80px]" data-id="element-11" data-mp="3mhq29pc1l3sl">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-12" data-mp="3hjoh8yv22ueh">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-12 md:mb-[64px]" data-id="element-13" data-mp="3clmx0alw8p1f">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-4" data-id="element-14" data-mp="3vk7q287ci4hp">
            LAS 5 DIMENSIONES
          </span>
          <h2 className="font-display text-[32px] md:text-[40px] font-bold text-carbon leading-[1.1]" data-id="element-15" data-mp="3ql4ioh3w7m6k">
            Cinco áreas evaluadas con criterios objetivos.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-16" data-mp="n3cwxkgcnygt">
          {dimensions.map((dim, idx) => <motion.div key={idx} className="bg-arena border border-salvia/20 rounded-xl p-8" initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.1
        }} data-id="element-17" data-mp="vfo86zhiwyx2" data-mpi={idx}>
              <div className="flex items-center gap-3 mb-4" data-id="element-18" data-mp="1n5156aluauj3">
                <span className="font-body text-[11px] uppercase font-semibold text-azul tracking-widest" data-id="element-19" data-mp="1s3u9pdj5fb74">
                  {dim.num}
                </span>
                <span className="font-body text-[11px] text-carbon/40" data-id="element-20" data-mp="1x0ugjqntohza">/</span>
                <span className="font-body text-[11px] uppercase font-semibold text-carbon tracking-widest" data-id="element-21" data-mp="2220blv4yghbz">
                  {dim.name}
                </span>
                <span className="font-body text-[11px] text-carbon/40 ml-auto" data-id="element-22" data-mp="2tuu7vxovy2ii">
                  {dim.points}
                </span>
              </div>

              <p className="font-body text-[15px] font-medium text-carbon italic mb-6" data-id="element-23" data-mp="38l1jbtgh6l9p">
                {dim.question}
              </p>

              <p className="font-body text-[13px] text-carbon/50 mb-3" data-id="element-24" data-mp="2ftrj3d6iae3w">
                Evalúa específicamente:
              </p>

              <ul className="space-y-2" data-id="element-25" data-mp="2awhtnxj4a2g2">
                {dim.items.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-26" data-mp="2ovr0w7pchm7w" data-mpi={i}>
                    <span className="text-carbon/40 mt-0.5 text-[12px]" data-id="element-27" data-mp="2ktmcpoho1hsn">·</span>
                    <span className="font-body text-[14px] text-carbon/70 leading-[1.6]" data-id="element-28" data-mp="2kvqk4gerwyxo">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}